var React = require('react');

function ArrowLCerulean (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Side","d":"M0,3.718,3.718,0,7.437,3.718","transform":"translate(4.072 0.354) rotate(90)","fill":"none","stroke":"#00B4DC","strokeWidth":"1"}));
}

ArrowLCerulean.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 4.779 8.144"};

module.exports = ArrowLCerulean;

ArrowLCerulean.default = ArrowLCerulean;
